import React from 'react';
import { useTranslation } from 'react-i18next';

import cloudsImage from '../../../../assets/clouds-icon.svg';

export const FileViewerError = () => {
  const { t } = useTranslation('inboxAndDocs');

  return (
    <div className="File-viewer-error-container">
      <img alt="" src={cloudsImage} />

      <p>{t('fileViewer.errorMessage')}</p>
    </div>
  );
};
